






































































































































import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { Funcionalidades } from '@/config/funcionalidades';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { AxiosVue } from '@/AxiosVue';
import { Vue, Component, Prop } from 'vue-property-decorator';
import MantenedorGridVerDetalle from '@/reusable/Grid/MantenedorGridVerDetalle.vue';
import { ServicioProxy, Accion } from '@/config/enums';
import { LoadingService } from '@/services/loadingService';
import moment from 'moment';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import { AlertaBackend } from '@/interfaces/Alertas';
import { Snotify } from '@/snotify/Snotify';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  GridReadyEvent,
  ICellRendererParams,
} from 'ag-grid-community';

@Component({
  components: {
    FormFieldsContainer,
    MantenedorGridVerDetalle,
    DatePicker,
  },
})
export default class EvidenciaBHP extends Vue {
  readonly funcionalidad: Funcionalidades = Funcionalidades.EvidenciaBHP;
  accionesTotales: PermisoAccion[] = [];
  readonly gridOptions: GridOptions;
  readonly loadingService = new LoadingService();
  seleccionarpatente: string = '';
  errorPatente: string = '';
  serverSide: any;
  buscador: string = '';
  hora: string = '';
  axios: AxiosVue = new AxiosVue(ServicioProxy.MS);
  enrichedGridOptions: GridOptions = null;
  now: string = moment().format('YYYY-MM-DD');
  gridApi: GridApi;
  velocidad: number = 0;
  columnApi: ColumnApi;
  lstorden: AlertaBackend[] = [];
  eventos: number | null = null;
  debounceTimeout: any = null;
  integrador: Array<any> = [];
  hourini: string = ''; // Inicializa como cadena vacía por defecto
  hourfin: string = '';
  readonly $snotify: Snotify;
  fechadesde: string = '';
  maxFecha: string = '';
  minFecha: string = '';
  errorVelocidad: string = ''; // Mensaje de error dinámico

  seleccionarintegrador: number | null = null;
  searchReport: string = '';
  tiposEventos: any[] = [];
  categorias: Array<any> = [];
  filteredData: any[] = [];
  rowData: any[] = [];
  filtrosAplicados: boolean = false;
  mounted() {
    this.Tiposdeeventos();
    this.integradores();
    this.setFechasLimite();
    if (!this.filtrosAplicados) {
      if (this.gridApi) {
        this.gridApi.showNoRowsOverlay();
      }
    }
  }
  setHorasPorDefecto() {
    this.hourini = moment()
      .hour(0)
      .minute(0)
      .second(0)
      .format('HH:mm:ss');
    this.hourfin = moment()
      .utc()
      .hour(0)
      .minute(0)
      .second(0)
      .format('HH:mm:ss');
  }
  constructor() {
    super();

    this.gridOptions = {
      onGridReady: this.onGridReady,
      rowSelection: 'multiple',
      pagination: true,
      paginationPageSize: 50,
      rowModelType: 'serverSide',
      cacheBlockSize: 10000,
      serverSideDatasource: this.serverSide,
      paginationAutoPageSize: false,
      suppressRowClickSelection: true,
      columnDefs: [
        {
          headerName: 'Patente',
          field: 'patente',
        },
        {
          headerName: 'Número de Evento',
          field: 'numero_evento',
        },
        {
          headerName: 'Velocidad',
          field: 'velocidad',
        },
        //BBXY17
        //SPHP37
        {
          headerName: 'Acelerómetro',
          field: 'acelerometro',
          cellRenderer: (params: any) => {
            const value = params.value;
            if (value && Object.keys(value).length === 0) {
              return '';
            }
            return value ? JSON.stringify(value, null, 2) : '';
          },
          cellStyle: { whiteSpace: 'pre-wrap', lineHeight: '15px' },
        },

        {
          headerName: 'Conductor',
          field: 'info_conductor',
          cellRenderer: (params: any) => {
            const value = params.value;
            if (value && Object.keys(value).length === 0) {
              return '';
            }
            return value ? JSON.stringify(value, null, 2) : '';
          },
          cellStyle: { whiteSpace: 'pre-wrap', lineHeight: '15px' },
        },

        {
          headerName: 'Fecha de Integrador UTC',
          field: 'fecha_integrador_utc',
        },
        {
          headerName: 'Fecha de Ingreso',
          field: 'fecha_ingreso',
        },
        {
          headerName: 'Fecha de Actividad',
          field: 'fechaactividad',
        },
        {
          headerName: 'Plataforma',
          field: 'plataforma',
        },
        {
          headerName: 'MID',
          field: 'mid',
        },
        {
          headerName: 'Detalles (jdata)',
          field: 'jdata',
          sortable: true,
          resizable: true,
          lockPinned: true,
          filter: true,
          autoHeight: true,
          width: 300,
          minWidth: 300,
          cellRenderer: (params: any) => {
            if (params.value) {
              return JSON.stringify(params.value, null, 2); // Muestra el JSON formateado
            }
            return '';
          },
          cellStyle: { whiteSpace: 'pre-wrap', lineHeight: '15px' },
        },
      ],
      overlayNoRowsTemplate:
        '<span class="ag-overlay-no-rows-center">No se encontraron datos con los filtros aplicados.</span>',
    };
  }
  //JXZW93
  velocidadRule = (v: string): boolean | string => {
    if (!/^\d*$/.test(v)) {
      return 'Solo se permiten valores numéricos.';
    }
    return parseInt(v, 10) <= 120 || 'La velocidad máxima permitida es 120.';
  };
  validarVelocidad(event: any) {
    const input = event.target.value.replace(/\D/g, '');
    this.velocidad = input;
  }

  patenteRule = (v: string): boolean | string =>
    v.length === 0 ||
    v.length >= 5 ||
    'La patente debe tener al menos 5 caracteres.';

  validarPatente(event: any) {
    const input = event.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    this.seleccionarpatente = input;
  }

  setFechasLimite() {
    const today = new Date();
    const lastWeek = new Date();
    lastWeek.setDate(today.getDate() - 7);
    this.now = today.toISOString().split('T')[0];
    this.minFecha = lastWeek.toISOString().split('T')[0];
  }
  cargarDatos(usandoBuscador = true) {
    const self = this;
    self.gridApi.purgeServerSideCache();
    if (!self.gridApi) return;
    self.loadingService.showLoading();
    const fecha = self.fechadesde
      ? moment(self.fechadesde).format('YYYY-MM-DD')
      : '';
    const hora = self.hourfin ? self.hourfin : ''; // Usar la hora si está presente

    // Combinar fecha y hora solo si ambos existen
    const fechaCompleta = fecha && hora ? `${fecha} ${hora}` : fecha || '';
    const requestData = {
      patente: self.seleccionarpatente,
      motor: self.seleccionarintegrador,
      tipoevento: self.eventos,
      fechadesde: fechaCompleta,
      filtro: self.buscador,
      velocidad: self.velocidad !== null ? String(self.velocidad) : '',
    };
    self.gridApi.purgeServerSideCache();
    if (usandoBuscador && self.buscador) {
      requestData.filtro = self.buscador;
    }
    self.gridApi.setServerSideDatasource({
      getRows: (params: any): void => {
        self.loadingService.showLoading();
        self.axios.http
          .post('Metabase/PostgenericA/evidencia_bhp/getEvidenciaBhp', {
            ...requestData,
          })
          .then((r: any) => {
            if (r.data.CODIGO_RESPUESTA === '1') {
              const rowData = r.data.data;
              console.log('Datos', rowData);
              if (rowData && rowData.length > 0) {
                params.successCallback(rowData, rowData.length); //indicar que solo hay 3 filas, si ese es el cas
                self.gridApi.hideOverlay();
                self.autoSizeAll();
              } else {
                params.successCallback([], 0);
                self.gridApi.showNoRowsOverlay();
                self.$snotify.error(
                  'No se encontraron datos con los filtros aplicados'
                );
              }
            } else {
              params.successCallback([], 0);
              self.gridApi.showNoRowsOverlay();
              self.$snotify.error('No se encontraron datos');
            }
            self.loadingService.hideLoading();
          })
          .catch((error: any) => {
            console.error(error);
            params.successCallback([], 0);
            self.gridApi.showNoRowsOverlay();
            self.$snotify.error(
              'Error al cargar los datos. Inténtelo más tarde.'
            );
          })
          .finally(() => {
            self.loadingService.hideLoading();
            self.gridApi.setDomLayout('autoHeight');
          });
      },
    });
  }
  async onGridReady(params: GridReadyEvent) {
    this.loadingService.showLoading();
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    this.gridApi.setServerSideDatasource(this.serverSide);
    this.gridApi.showNoRowsOverlay();
    this.loadingService.hideLoading();
  }

  buscarDatos() {
    this.buscador = '';
    this.filtrosAplicados = true;
    this.cargarDatos(false);
  }

  autoSizeAll() {
    const allColumns = this.columnApi.getAllColumns();
    this.columnApi.autoSizeColumns(allColumns);
  }
  limpiarCampos() {
    this.loadingService.showLoading();
    this.seleccionarintegrador = null;
    this.seleccionarpatente = '';
    this.eventos = null;
    this.fechadesde = '';
    this.hourfin = '';
    this.filtrosAplicados = false;
    this.eventos = 1;
    this.velocidad = 0;
    this.gridApi.purgeServerSideCache();

    this.gridApi.setRowData([]);

    this.cargarDatos();

    this.loadingService.hideLoading();
  }

  limpiarCampos2() {
    this.buscador = '';
    this.cargarDatos();
  }
  onQuickFilterChanged() {
    if (this.gridApi) {
      const timeOutId = setTimeout(() => {
        this.cargarDatos(true);
        clearTimeout(timeOutId);
      }, 1500);
    }
  }

  async Tiposdeeventos() {
    try {
      const self = this;
      this.loadingService.showLoading();

      const response = await self.axios.http.post(
        'Metabase/PostgenericA/evidencia_bhp/getTiposEventos'
      );

      if (response.data.CODIGO_RESPUESTA === '1') {
        this.tiposEventos = response.data.data;
        console.log('data', this.tiposEventos);
        const todosEvento = this.tiposEventos.find(
          evento => evento.nombre === 'Todos'
        );
        if (todosEvento) {
          this.eventos = todosEvento.id;
        }
      } else {
        console.log('La petición adicional no tuvo éxito:', response.data);
      }
    } catch (error) {
      console.error('Error en la nueva petición adicional:', error);
    } finally {
      this.loadingService.hideLoading();
    }
  }
  async integradores() {
    try {
      const self = this;
      this.loadingService.showLoading();

      const response = await self.axios.http.post(
        'Metabase/PostgenericA/evidencia_bhp/getIntegradores'
      );

      if (response.data.CODIGO_RESPUESTA === '1') {
        console.log('Respuesta exitosa de la nueva petición:', response.data);
        this.integrador = response.data.data;
        console.log('data', this.tiposEventos);
      } else {
        console.log('La petición adicional no tuvo éxito:', response.data);
      }
    } catch (error) {
      console.error('Error en la nueva petición adicional:', error);
    } finally {
      this.loadingService.hideLoading();
    }
  }
  async getCSV(): Promise<void> {
    const fecha = this.fechadesde
      ? moment(this.fechadesde).format('YYYY-MM-DD')
      : '';
    const hora = this.hourfin ? this.hourfin : '';

    const fechaCompleta = fecha && hora ? `${fecha} ${hora}` : fecha || '';
    const body = {
      patente: this.seleccionarpatente,
      motor: this.seleccionarintegrador,
      tipoevento: this.eventos,
      fechadesde: fechaCompleta,
      filtro: this.buscador,
      velocidad: this.velocidad,
    };

    this.loadingService.showLoading();

    try {
      const response = await this.axios.http.post(
        'Metabase/PostgenericA/evidencia_bhp/download',
        body
      );

      if (response.data && response.data.CODIGO_RESPUESTA === '1') {
        const { filename, token } = response.data;

        let _url_base = process.env.VUE_APP_SERVICIO_MS;

        const downloadUrl = `${_url_base}descarga_reporte?tk=${token}`;

        window.open(downloadUrl, '_blank');
      } else {
        this.$snotify.error(response.data.MENSAJE_RESPUESTA, { timeout: 3000 });
      }
    } catch (error) {
      console.error('Error al generar el reporte:', error);
      this.$snotify.error(
        'Error al generar el reporte. Por favor, inténtelo de nuevo más tarde.',
        { timeout: 3000 }
      );
    } finally {
      this.loadingService.hideLoading();
    }
  }
}
